import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  wrapper: {
    marginTop: 12,
    [breakpoints.up('sm')]: {
      marginTop: 16,
    },
  },
  separator: {
    borderBottom: `1px solid ${palette.grey['200']}`,
    paddingBottom: 24,
  },
}));
